var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9034 18.9816C12.288 18.8278 12.475 18.3913 12.3212 18.0067C12.1674 17.6221 11.7309 17.4351 11.3463 17.5889L11.9034 18.9816ZM21.7082 9.25749C21.7082 9.67171 22.044 10.0075 22.4582 10.0075C22.8724 10.0075 23.2082 9.67171 23.2082 9.25749H21.7082ZM21.8296 3.95049L21.551 4.64685L21.8296 3.95049ZM14.8646 1.46161L15.1431 2.15796L14.8646 1.46161ZM15.6073 1.46161L15.3288 2.15796L15.6073 1.46161ZM1.42011 17.0923L1.14157 17.7886L1.42011 17.0923ZM8.38512 19.5812L8.66366 20.2775L8.38512 19.5812ZM7.64234 19.5812L7.92088 18.8848L7.64234 19.5812ZM11.3463 17.5889L8.10657 18.8848L8.66366 20.2775L11.9034 18.9816L11.3463 17.5889ZM7.92088 18.8848L1.69866 16.3959L1.14157 17.7886L7.36379 20.2775L7.92088 18.8848ZM1.5415 16.1638V2.79008H0.0415039V16.1638H1.5415ZM1.88435 2.55796L7.36379 4.74974L7.92088 3.35702L2.44144 1.16525L1.88435 2.55796ZM8.66366 4.74974L15.1431 2.15796L14.586 0.765248L8.10657 3.35702L8.66366 4.74974ZM15.3288 2.15796L21.551 4.64685L22.1081 3.25414L15.8859 0.765248L15.3288 2.15796ZM21.7082 4.87897V9.25749H23.2082V4.87897H21.7082ZM21.551 4.64685C21.6459 4.68482 21.7082 4.77675 21.7082 4.87897H23.2082C23.2082 4.16339 22.7725 3.5199 22.1081 3.25414L21.551 4.64685ZM15.1431 2.15796C15.2027 2.13412 15.2692 2.13412 15.3288 2.15796L15.8859 0.765248C15.4687 0.59836 15.0032 0.598361 14.586 0.765248L15.1431 2.15796ZM7.36379 4.74974C7.78101 4.91663 8.24644 4.91663 8.66366 4.74974L8.10657 3.35702C8.04697 3.38087 7.98048 3.38087 7.92088 3.35702L7.36379 4.74974ZM1.5415 2.79008C1.5415 2.61322 1.72014 2.49228 1.88435 2.55796L2.44144 1.16525C1.29192 0.705443 0.0415039 1.55202 0.0415039 2.79008H1.5415ZM1.69866 16.3959C1.60374 16.3579 1.5415 16.266 1.5415 16.1638H0.0415039C0.0415039 16.8794 0.477169 17.5229 1.14157 17.7886L1.69866 16.3959ZM8.10657 18.8848C8.04697 18.9086 7.98048 18.9086 7.92088 18.8848L7.36379 20.2775C7.78101 20.4444 8.24644 20.4444 8.66366 20.2775L8.10657 18.8848Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01367 4.20197V19.3686",
    stroke: "#000000",
    strokeWidth: 1.8240000000000003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2363 2.03528V8.53528",
    stroke: "#000000",
    strokeWidth: 1.8240000000000003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4582 15.3964C22.4582 17.7896 18.3514 22.6186 18.1248 22.6186C17.8983 22.6186 13.7915 17.7896 13.7915 15.3964C13.7915 13.0032 15.7316 11.0631 18.1248 11.0631C20.5181 11.0631 22.4582 13.0032 22.4582 15.3964Z",
    stroke: "#000000",
    strokeWidth: 1.8240000000000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16H19",
    stroke: "#000000",
    strokeWidth: 1.8240000000000003,
    strokeLinecap: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6e2b142ebcad15d09d50061542630a7f.svg";
export { ForwardRef as ReactComponent };